import React, { useState, useRef } from "react";
import "../TeamSessionWithDropStyle.css";
import useDrag from "../../hooks/useDrag";
import View from "./view";

export default ({data, id }) => {
    const dragRef = useRef();
    const [classValue, setClassValue] = useState("grab");
    const { dragState } = useDrag({
        id,
        ref: dragRef,
        onDragStart: () => setClassValue("grabbing"),
        onDragEnd: () => {
            setClassValue("grab");
        }
    });
    return <View ref={dragRef} data={data} classValue={classValue} state={dragState} />;
};
